import { Button, Col, Modal, Row, Table } from "react-bootstrap";
import { CTeEventoDto, EStatusEnvioCTeEvento } from "../CTe.Evento.Dto";

interface Props {
  show: boolean;
  evento: CTeEventoDto | undefined;
  onReturn: () => void;
  onSend: (evento: CTeEventoDto) => void;
  onDelete: (evento: CTeEventoDto) => void;
}

const CTeEventoModalPropriedades = (props: Props) => {
  const finalizado =
    props.evento?.codigoStatusEnvio === EStatusEnvioCTeEvento.Finalizada;

  const onReturnHandler = () => {
    props.onReturn();
  };

  const onSendHandler = () => {
    if (props.evento) {
      props.onSend(props.evento);
    }
  };

  const onDeleteHandler = () => {
    if (props.evento) {
      props.onReturn();
      props.onDelete(props.evento);
    }
  };

  return (
    <Modal
      show={props.show}
      centered
      size={props.evento?.correcoes?.length ? "lg" : undefined}
      onHide={onReturnHandler}
    >
      <Modal.Header closeButton>
        <Modal.Title>Propriedades do Evento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-2">
          <Col xs={12}>
            <strong>Tipo de Evento:</strong>{" "}
            {props.evento?.tipoEventoDescricao || props.evento?.tipoEvento}
          </Col>
        </Row>
        {props.evento?.cancelamento?.justificativaCancelamento && (
          <Row className="mb-2">
            <Col xs={12}>
              <strong>Justificativa:</strong>{" "}
              {props.evento.cancelamento.justificativaCancelamento}
            </Col>
          </Row>
        )}

        {props.evento?.correcoes && props.evento.correcoes.length > 0 && (
          <div className="mb-3">
            <strong>Correções da CC-e:</strong>
            <Table responsive bordered hover size="sm" className="mt-1">
              <thead className="table-light">
                <tr>
                  <th>Grupo</th>
                  <th>Campo</th>
                  <th>Valor Alterado</th>
                  <th style={{ width: "90px" }}>Nº Item</th>
                </tr>
              </thead>
              <tbody>
                {props.evento.correcoes.map((c, idx) => (
                  <tr key={c.id ?? idx}>
                    <td>{c.grupoAlterado}</td>
                    <td>{c.campoAlterado}</td>
                    <td className="text-break">{c.valorAlterado}</td>
                    <td>{c.numeroItemAlterado ?? "-"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}

        <Row className="mb-2">
          <Col xs={12}>
            <strong>Status Envio:</strong> {props.evento?.codigoStatusEnvio} -{" "}
            {props.evento?.codigoStatusEnvioDescricao}
          </Col>
        </Row>
        {props.evento?.codigoStatusResposta != null && (
          <Row className="mb-2">
            <Col xs={12}>
              <strong>Status Resposta:</strong> {props.evento.codigoStatusResposta} -{" "}
              {props.evento.descricaoMotivoResposta}
            </Col>
          </Row>
        )}
        {props.evento?.numeroProtocolo && (
          <Row className="mb-2">
            <Col xs={12}>
              <strong>Protocolo:</strong> {props.evento.numeroProtocolo}
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        {!finalizado && (
          <>
            <Button
              variant="outline-danger"
              className="messagebox-btn-cancel"
              onClick={onDeleteHandler}
            >
              Excluir
            </Button>
            <Button
              variant="outline-primary"
              className="messagebox-btn-cancel"
              onClick={onSendHandler}
            >
              Enviar
            </Button>
          </>
        )}
        <Button
          variant="outline-secondary"
          className="messagebox-btn-cancel"
          onClick={onReturnHandler}
        >
          Sair
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CTeEventoModalPropriedades;
